import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    //console.log('Recibido en interpret:', data)
    const consult = `Quiero que interpretes una **Tirada de Abundancia y Prosperidad** con 10 cartas, analizando el estaro financiero y energético del consultante ${
        data.consultante
    }, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' + data.consulta + ','
            : ''
    } según estas cartas: **Energía actual respecto a la abundancia:** ${formatCardLabel(cards[0])}, **Bloqueo o creencia limitante:** ${formatCardLabel(cards[1])}, **Origen del bloqueo:** ${formatCardLabel(cards[2])}, **Recursos ocultos o talentos desaprovechados:** ${formatCardLabel(cards[3])}, **Oportunidades en camino:** ${formatCardLabel(cards[4])}, **Acción clave para atraer prosperidad:** ${formatCardLabel(cards[5])}, **Cómo gestionar mejor sus finanzas:** ${formatCardLabel(cards[6])} **Consejo del universo:**: ${formatCardLabel(cards[7])} **Posibles obstáculos futuros:** ${formatCardLabel(cards[8])} y **Resultado final si se sigue el consejo:** ${formatCardLabel(cards[9])}. Explica detalladamente cada carta y su significado dentro de la tirada. Luego, brinda consejos específicos para para atraer abundancia y prosperidad en la vida del consultate basados en la interpretación. Mantén un tono profesional y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 parrafos despues de la interpretación, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
